<template>
  <v-select
    :value="value"
    :options="options"
    :clearable="clearable"
    :disabled="disabled"
    label="name"
    class="device-tag-select"
    @input="$emit('input', $event)"
  >
    <template #option="tag">
      <div class="d-flex align-items-center">
        <custom-icon
          v-if="tag.icon"
          :name="tag.icon"
          :color="tag.icon_color"
          size="18"
          class="mr-50"
        />
        <span>{{ tag.name }}</span>
        <small v-if="inherited" class="ml-25 text-muted">(Area)</small>
      </div>
    </template>
    <template #selected-option="tag">
      <div class="d-flex align-items-center">
        <custom-icon
          v-if="tag.icon"
          :name="tag.icon"
          :color="tag.icon_color"
          size="16"
          class="mr-50"
        />
        <span>{{ tag.name }}</span>
      </div>
    </template>
  </v-select>
</template>

<script>
import vSelect from "vue-select";
import CustomIcon from "@/components/CustomIcon.vue";

export default {
  name: "DeviceTagSelect",
  components: {
    CustomIcon,
    vSelect,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    inherited: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped>
.device-tag-select {
  min-width: 150px;
}
</style>
